import { Box, CardMedia } from '@mui/material'
import React from 'react'
const Logo = ({ logo }) => {
    return (
        <>
            <Box sx={{ position: 'relative', zIndex: 2, width: '100%', mb: 1, mt: 2 }}>
                <CardMedia component={'img'} src={logo} className={'nav-logo'} sx={{ width:{md: 'fit-content',xs:175}, objectFit: 'contain', m:'auto'}} />
            </Box>
        </>
    )
}

export default Logo